import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { ContactsApiProvider } from '../../../services';
import { loginActions } from '../../../actions/login.actions';

import EnterUserName from './EnterUserName';
import NewPassword from './NewPassword';
import EnterMethod from './EnterMethod';
import VerificationCode from './VerificationCode';
import { LOGIN } from '../../../constants';
import logo from 'assets/img/logo-xomePro.png';

class ForgotPassword extends React.Component {
  static propTypes = {
    deliveryMethod: PropTypes.array.isRequired,
    formPosition: PropTypes.string.isRequired,
    errorMessage: PropTypes.string,
    setFormPosition: PropTypes.func.isRequired,
    isResetError: PropTypes.bool
  }

  state = {
    username: '',
    method: '',
    newPassword: '',
    deliveryType: '',
    deliveryDestination: '',
    validationCode: '',
    authenticationCode: ''
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      loginFailed: false
    });
  }

  handleGoback = (e) => {
    e.preventDefault();
    const keys = Object.keys(LOGIN.FORM_POSITION);
    const position = keys.indexOf(this.props.formPosition);
    const prevPosition = keys[position - 1];

    if (position > 0 && position < keys.length) {
      this.props.setFormPosition(prevPosition);
    }
    return false;
  }

renderForm = () => {
  const { formPosition } = this.props;
  const props = { ...this.props, ...this };
  switch (formPosition) {
    case LOGIN.FORM_POSITION.ENTER_USERNAME:
      return <EnterUserName {...props} />;
    case LOGIN.FORM_POSITION.ENTER_METHOD:
      return <EnterMethod {...props} />;
    case LOGIN.FORM_POSITION.ENTER_CODE:
      return <VerificationCode {...props} />;
    case LOGIN.FORM_POSITION.ENTER_PASSWORD:
      return <NewPassword {...props} />;
    default:
      return <EnterUserName {...props} />;
  }
}

render () {
  return (
    <div className='login-background background-header bg_img'>
      <div className='header-logo'>
        <img className='header-logo-image' src={logo} />
      </div>
      <div>
        {this.renderForm({ ...this.props })}
      </div>
    </div>
  );
}
}

const mapStateToProps = (state) => {
  return {
    deliveryMethod: _.get(state.login, 'deliveryMethod', []),
    formPosition: _.get(state.login, 'formPosition', ''),
    sendMethod: _.get(state.login, 'sendMethod', {}),
    validationCode: _.get(state.login, 'validationCode', {}),
    isResetError: _.get(state.login, 'resetError', null),
    errorMessage: _.get(state.login, 'errorMessage', null),
    codeExpiration: _.get(state.login, 'codeExpiration', null)
  };
};

const mapDispatchToProps = dispatch => ({
  fetchMethods: bindActionCreators(loginActions.fetchMethods, dispatch),
  sendValidationCode: bindActionCreators(loginActions.sendValidationCode, dispatch),
  validateCode: bindActionCreators(loginActions.validateCode, dispatch),
  sendNewCredentials: bindActionCreators(loginActions.sendNewCredentials, dispatch),
  setFormPosition: bindActionCreators(loginActions.setFormPosition, dispatch),
  setSendMethod: bindActionCreators(loginActions.setSendMethod, dispatch),
  setExpirationTime: bindActionCreators(loginActions.setExpirationTime, dispatch),
  login: bindActionCreators(ContactsApiProvider.login, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ForgotPassword));
